import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[questionPlaceholder]',
})
export class QuestionPlaceholderDirective {
  public viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
}
